Object.defineProperty(exports, "__esModule", {
  value: true
});

// Customizable Area Start
exports.validationApiContentType = "application/json";
exports.productApiContentType = "application/json";
exports.apiMethodTypeGet = "GET";
exports.productAPiEndPoint = "catalogue/catalogues";
exports.brandAPiEndPoint = "catalogue/brands";
exports.filterbrandAPiEndPoint = "filter_items/filtering?q[brand_id]=";
exports.singleCategoryAPiEndPoint = "filter_items/filtering?q[category_id]=";
exports.cataloguesAPiEndPoint = "filter_items/filtering?";
exports.excludeOutOfStockTxt = "Exclude out of stock";
exports.priceRangeTxt = "Price range";
exports.brandTxt = "Brand";
exports.categoryTxt = "Category";
exports.cancel = "Cancel";
exports.apply = "Apply";
exports.searchForBrandTxt = "Search for a Brand";
exports.searchForCategoryTxt = "Search for a Category";
exports.webFilterOptionsTxt = "Web Filter Options";
exports.emptyBlockTxt = "Empty Block";

exports.filterTxt = "Filter";
exports.filterTitle = "Filters:";

exports.languagesSpokenApiEndPoint = "bx_block_language/user_languages"
exports.locationsApiEndPoint = "account_block/india_states"
exports.skillsCategoriesApiEndPoint = "bx_block_categories/category_lists"

exports.GENDER_OPTIONS = [
  { key: "Male", value: "Male" },
  { key: "Female", value: "Female" },
  { key: "Others", value: "Others" },
]

exports.AGE_RANGE_OPTIONS = [
  { key: "0-10", value: "0-10" },
  { key: "10-20", value: "10-20" },
  { key: "20-30", value: "20-30" },
  { key: "30-40", value: "30-40" },
  { key: "40-50", value: "40-50" },
  { key: "50-60", value: "50-60" },
  { key: "60-70", value: "60-70" },
  { key: "70-80", value: "70-80" },
  { key: "80-90", value: "80-90" },
  { key: "90-100", value: "90-100" },
]
// Customizable Area End
